// GENERATED by scripts/gen-wire-types.mjs from core/src/wire.rs.
// Do not edit by hand. Run `npm run wasm:node` (or `npm run wire-types`).

export const EV_JUMP = 1 << 0;
export const EV_DASH = 1 << 1;
export const EV_WALLJUMP = 1 << 2;
export const EV_LAND = 1 << 3;
export const EV_FOOTSTEP = 1 << 4;
export const EV_JUMPPAD = 1 << 5;
export const EV_TELEPORT = 1 << 6;
export const EV_PREJUMP = 1 << 7;
export const EV_FIRE = 1 << 8;
export const EV_EXPLODE = 1 << 9;
export const EV_HIT = 1 << 10;
export const EV_PAIN = 1 << 11;
export const EV_DEATH = 1 << 12;
export const EV_PICKUP = 1 << 13;
export const EV_KILL_CONFIRM = 1 << 14;
